import type { Route } from 'react-resource-router';

/**
 * Create route entry with component/resources/etc. override
 * @deprecated Import from `@atlassian/jira-route-entry` instead
 * @param {Route} baseRoute - base route object that contains matching info
 * @param {Partial<Route>} opts - route definition to fill/override
 */
export const createEntry = (baseRoute: Route, opts: Partial<Route>): Route =>
	Object.assign(baseRoute, opts);
